// Mock data for the Syndicate of Pilots application
// This file contains comprehensive sample data for all screens

export const mockData = {
  // Members data
  members: [
    {
      id: "1",
      name: "Captain Sarah Ahmed",
      email: "sarah.ahmed@syndicate.eg",
      phone: "+20 100 123 4567",
      licenseNumber: "EG-001234",
      licenseStatus: "active" as const,
      membershipType: "pilot" as const,
      joinDate: "2020-03-15",
      renewalDate: "2024-12-31",
      qualifications: ["ATPL", "B737 Type Rating", "CRM Instructor"],
      subscriptionStatus: "active" as const,
      unionHistory: [
        {
          id: "1",
          date: "2020-03-15",
          action: "Joined",
          description: "Initial membership registration",
        },
        {
          id: "2",
          date: "2023-12-31",
          action: "Renewal",
          description: "Annual membership renewal",
        },
      ],
    },
    {
      id: "2",
      name: "Captain Mohamed Hassan",
      email: "mohamed.hassan@syndicate.eg",
      phone: "+20 100 234 5678",
      licenseNumber: "EG-002345",
      licenseStatus: "active" as const,
      membershipType: "pilot" as const,
      joinDate: "2019-07-20",
      renewalDate: "2024-11-15",
      qualifications: ["ATPL", "A320 Type Rating", "Safety Officer"],
      subscriptionStatus: "active" as const,
      unionHistory: [
        {
          id: "3",
          date: "2019-07-20",
          action: "Joined",
          description: "Initial membership registration",
        },
        {
          id: "4",
          date: "2023-11-15",
          action: "Renewal",
          description: "Annual membership renewal",
        },
      ],
    },
    {
      id: "3",
      name: "Captain Fatma Ibrahim",
      email: "fatma.ibrahim@syndicate.eg",
      phone: "+20 100 345 6789",
      licenseNumber: "EG-003456",
      licenseStatus: "active" as const,
      membershipType: "pilot" as const,
      joinDate: "2021-01-10",
      renewalDate: "2024-10-30",
      qualifications: ["ATPL", "B777 Type Rating", "Training Captain"],
      subscriptionStatus: "active" as const,
      unionHistory: [
        {
          id: "5",
          date: "2021-01-10",
          action: "Joined",
          description: "Initial membership registration",
        },
        {
          id: "6",
          date: "2023-10-30",
          action: "Renewal",
          description: "Annual membership renewal",
        },
      ],
    },
    {
      id: "4",
      name: "Captain Ahmed Ali",
      email: "ahmed.ali@syndicate.eg",
      phone: "+20 100 456 7890",
      licenseNumber: "EG-004567",
      licenseStatus: "expired" as const,
      membershipType: "pilot" as const,
      joinDate: "2018-05-12",
      renewalDate: "2023-12-31",
      qualifications: ["ATPL", "A330 Type Rating"],
      subscriptionStatus: "expired" as const,
      unionHistory: [
        {
          id: "7",
          date: "2018-05-12",
          action: "Joined",
          description: "Initial membership registration",
        },
        {
          id: "8",
          date: "2022-12-31",
          action: "Renewal",
          description: "Annual membership renewal",
        },
      ],
    },
    {
      id: "5",
      name: "Captain Nour El-Din",
      email: "nour.eldin@syndicate.eg",
      phone: "+20 100 567 8901",
      licenseNumber: "EG-005678",
      licenseStatus: "active" as const,
      membershipType: "retired" as const,
      joinDate: "2015-09-08",
      renewalDate: "2024-08-15",
      qualifications: ["ATPL", "B747 Type Rating", "Retired Captain"],
      subscriptionStatus: "active" as const,
      unionHistory: [
        {
          id: "9",
          date: "2015-09-08",
          action: "Joined",
          description: "Initial membership registration",
        },
        {
          id: "10",
          date: "2023-08-15",
          action: "Renewal",
          description: "Annual membership renewal",
        },
        {
          id: "11",
          date: "2023-06-01",
          action: "Status Change",
          description: "Changed to retired membership",
        },
      ],
    },
  ],

  // Financial records data
  financialRecords: [
    {
      id: "1",
      type: "income" as const,
      amount: 50000,
      description: "Annual membership fees - Q1 2024",
      date: "2024-01-15",
      category: "Membership Fees",
      reference: "MEM-2024-001",
    },
    {
      id: "2",
      type: "income" as const,
      amount: 25000,
      description: "Training program fees",
      date: "2024-01-20",
      category: "Training",
      reference: "TRN-2024-001",
    },
    {
      id: "3",
      type: "expense" as const,
      amount: 15000,
      description: "Office rent - January 2024",
      date: "2024-01-01",
      category: "Administrative",
      reference: "ADM-2024-001",
    },
    {
      id: "4",
      type: "expense" as const,
      amount: 8000,
      description: "Legal consultation fees",
      date: "2024-01-10",
      category: "Legal",
      reference: "LEG-2024-001",
    },
    {
      id: "5",
      type: "income" as const,
      amount: 12000,
      description: "Event sponsorship",
      date: "2024-01-25",
      category: "Sponsorship",
      reference: "SPN-2024-001",
    },
    {
      id: "6",
      type: "expense" as const,
      amount: 5000,
      description: "IT infrastructure maintenance",
      date: "2024-01-30",
      category: "Technology",
      reference: "TEC-2024-001",
    },
  ],

  // Cases data
  cases: [
    {
      id: "1",
      title: "Employment Dispute - Captain Ahmed",
      type: "labor" as const,
      status: "open" as const,
      assignedTo: "Dr. Ahmed Hassan",
      priority: "high" as const,
      createdDate: "2024-01-15",
      dueDate: "2024-02-15",
      description:
        "Dispute regarding overtime compensation and working conditions",
      documents: ["Employment Contract", "Timesheet Records", "Company Policy"],
      caseNumber: "CASE-2024-001",
      parties: ["Captain Ahmed Ali", "EgyptAir"],
    },
    {
      id: "2",
      title: "License Renewal Issue",
      type: "regulatory" as const,
      status: "in-progress" as const,
      assignedTo: "Ms. Fatma Ibrahim",
      priority: "medium" as const,
      createdDate: "2024-01-10",
      dueDate: "2024-01-30",
      description:
        "Assistance with pilot license renewal process and documentation",
      documents: [
        "License Application",
        "Medical Certificate",
        "Training Records",
      ],
      caseNumber: "CASE-2024-002",
      parties: ["Captain Sarah Ahmed", "ECAA"],
    },
    {
      id: "3",
      title: "Contract Review - New Employment",
      type: "dispute" as const,
      status: "resolved" as const,
      assignedTo: "Mr. Omar Ali",
      priority: "low" as const,
      createdDate: "2023-12-20",
      dueDate: "2024-01-10",
      description: "Review and negotiation of new employment contract terms",
      documents: ["Draft Contract", "Previous Contract", "Negotiation Notes"],
      caseNumber: "CASE-2023-045",
      parties: ["Captain Mohamed Hassan", "Nile Air"],
    },
  ],

  // Meetings data
  meetings: [
    {
      id: "1",
      title: "Board Meeting - Q1 2024",
      date: "2024-02-15",
      type: "board" as const,
      status: "scheduled" as const,
      agenda: [
        "Financial report review",
        "New member applications",
        "Training program updates",
        "Legal matters discussion",
      ],
      attendees: [
        "Captain Sarah Ahmed",
        "Captain Mohamed Hassan",
        "Captain Fatma Ibrahim",
      ],
      minutes:
        "Board meeting to discuss Q1 2024 activities and upcoming initiatives.",
      resolutions: [
        "Approved budget allocation for training programs",
        "Accepted 5 new member applications",
      ],
      votingItems: [
        {
          id: "1",
          title: "Budget Approval for Q2 2024",
          description:
            "Approve the proposed budget allocation for the second quarter",
          options: ["for", "against"],
          votes: {
            for: ["user1", "user2", "user3"],
            against: ["user4"],
          },
          status: "active" as const,
          deadline: "2024-02-15",
        },
      ],
    },
    {
      id: "2",
      title: "Committee Meeting - Training",
      date: "2024-01-25",
      type: "committee" as const,
      status: "completed" as const,
      agenda: [
        "Training program evaluation",
        "New instructor recruitment",
        "Safety protocol updates",
      ],
      attendees: [
        "Captain Fatma Ibrahim",
        "Captain Ahmed Ali",
        "Training Coordinator",
      ],
      minutes:
        "Discussed current training programs and planned improvements for 2024.",
      resolutions: [
        "Hired 2 new training instructors",
        "Updated safety protocols",
      ],
    },
  ],

  // Events data
  events: [
    {
      id: "1",
      title: "Annual Pilot Conference 2024",
      date: "2024-03-15",
      type: "conference" as const,
      status: "planned" as const,
      location: "Cairo Marriott Hotel",
      description:
        "Annual conference for all pilot members with industry updates and networking",
      attendees: 200,
      budget: 100000,
    },
    {
      id: "2",
      title: "Safety Training Workshop",
      date: "2024-02-20",
      type: "training" as const,
      status: "confirmed" as const,
      location: "Syndicate Training Center",
      description: "Mandatory safety training for all active pilots",
      attendees: 50,
      budget: 25000,
    },
    {
      id: "3",
      title: "New Member Orientation",
      date: "2024-02-10",
      type: "orientation" as const,
      status: "completed" as const,
      location: "Syndicate Office",
      description: "Orientation session for new members joining in Q1 2024",
      attendees: 15,
      budget: 5000,
    },
  ],

  // Correspondence data
  correspondence: [
    {
      id: "1",
      title: "Request for Pilot Training Program",
      type: "incoming" as const,
      reference: "ECAA-2024-001",
      date: "2024-01-15",
      from: "Egyptian Civil Aviation Authority",
      to: "Syndicate of Pilots",
      subject: "Request for Pilot Training Program",
      content:
        "We would like to request information about your pilot training programs and potential collaboration opportunities.",
      priority: "high" as const,
      status: "draft" as const,
      attachments: [],
    },
    {
      id: "2",
      title: "Membership Application Response",
      type: "outgoing" as const,
      reference: "MEM-2024-002",
      date: "2024-01-20",
      from: "Syndicate of Pilots",
      to: "Captain Ahmed Hassan",
      subject: "Membership Application Approved",
      content:
        "Congratulations! Your membership application has been approved. Welcome to the Syndicate of Pilots.",
      priority: "medium" as const,
      status: "sent" as const,
      attachments: ["Membership Certificate", "Welcome Package"],
    },
  ],

  // Assets data
  assets: [
    {
      id: "1",
      name: "Dell OptiPlex 7090",
      type: "hardware" as const,
      category: "Desktop Computer",
      serialNumber: "DL123456789",
      purchaseDate: "2023-06-15",
      cost: 15000,
      status: "active" as const,
      assignedTo: "Admin Office",
      location: "Office Floor 1",
      maintenanceSchedule: [
        {
          id: "1",
          date: "2024-06-15",
          type: "preventive" as const,
          description: "Annual maintenance check and cleaning",
          cost: 2000,
          technician: "IT Support Team",
          nextDue: "2025-06-15",
        },
      ],
    },
    {
      id: "2",
      name: "HP LaserJet Pro",
      type: "hardware" as const,
      category: "Printer",
      serialNumber: "HP987654321",
      purchaseDate: "2023-08-20",
      cost: 8000,
      status: "active" as const,
      assignedTo: "Reception",
      location: "Office Floor 1",
      maintenanceSchedule: [
        {
          id: "2",
          date: "2024-02-20",
          type: "repair" as const,
          description: "Toner replacement and printer cleaning",
          cost: 500,
          technician: "Printer Service Team",
          nextDue: "2024-08-20",
        },
      ],
    },
    {
      id: "3",
      name: "Microsoft Office 365",
      type: "software" as const,
      category: "Productivity Suite",
      serialNumber: "MS365-2024-001",
      purchaseDate: "2024-01-01",
      cost: 12000,
      status: "active" as const,
      assignedTo: "All Staff",
      location: "Cloud",
      maintenanceSchedule: [],
    },
  ],

  // Tickets data
  tickets: [
    {
      id: "1",
      title: "Printer Not Working",
      description: "The office printer is not responding to print jobs",
      type: "hardware" as const,
      priority: "medium" as const,
      status: "open" as const,
      reporter: "Secretary 1",
      createdDate: "2024-01-20",
      attachments: [],
      comments: [
        {
          id: "1",
          author: "IT Support",
          date: "2024-01-20",
          content: "Checking printer connection and drivers",
          isInternal: false,
        },
      ],
    },
    {
      id: "2",
      title: "Email Server Issue",
      description: "Intermittent email delivery problems",
      type: "software" as const,
      priority: "high" as const,
      status: "in-progress" as const,
      reporter: "Admin",
      createdDate: "2024-01-18",
      attachments: ["Error Logs"],
      comments: [
        {
          id: "2",
          author: "IT Support",
          date: "2024-01-18",
          content: "Investigating server logs and network connectivity",
          isInternal: false,
        },
        {
          id: "3",
          author: "IT Support",
          date: "2024-01-19",
          content: "Applied server patch, monitoring for improvements",
          isInternal: false,
        },
      ],
    },
  ],

  // Committees data
  committees: [
    {
      id: "1",
      name: "International Relations Committee",
      type: "international" as const,
      description:
        "Manages international partnerships and cooperation with global aviation organizations",
      chairperson: "Captain Sarah Ahmed",
      members: ["1", "2", "3"],
      status: "active" as const,
      establishedDate: "2020-01-15",
      budget: 100000,
      objectives: [
        "Build international partnerships",
        "Represent syndicate globally",
        "Coordinate with ICAO and other international bodies",
      ],
    },
    {
      id: "2",
      name: "Dispute Resolution Committee",
      type: "dispute" as const,
      description: "Handles member disputes and legal matters",
      chairperson: "Captain Mohamed Hassan",
      members: ["2", "4", "5"],
      status: "active" as const,
      establishedDate: "2019-06-01",
      budget: 75000,
      objectives: [
        "Resolve member disputes",
        "Provide legal support",
        "Maintain fair representation",
      ],
    },
    {
      id: "3",
      name: "Social Committee",
      type: "social" as const,
      description: "Organizes social events and member activities",
      chairperson: "Captain Fatma Ibrahim",
      members: ["3", "1", "2"],
      status: "active" as const,
      establishedDate: "2021-03-10",
      budget: 50000,
      objectives: [
        "Organize social events",
        "Promote member engagement",
        "Build community spirit",
      ],
    },
  ],
};

export default mockData;
